import { SignatureType } from '@modusign/react-signing/types';
import { useMemo } from 'react';

import { createAbsoluteNumber } from '@app/features/apply-react-signing/components/FieldRenderer/libs/createAbsoluteNumber';
import {
  AbsoluteNumber,
  AbsoluteSize,
} from '@app/features/apply-react-signing/components/FieldRenderer/types';
import { MIN_STAMP_SIZE } from '@app/features/apply-react-signing/libs/signatureFieldSize';

const MIN_ICON_SIZE = 18;
const BASE_ICON_SIZE = 24;

export function useSignatureFieldMarkerIcon(
  allow: SignatureType[],
  size: AbsoluteSize,
  uploadOnly: boolean
): {
  iconSize: AbsoluteNumber;
  markerIconType: 'CIRCLE' | 'SIGN' | 'STAMP' | 'STAMP_UPLOAD_ONLY';
} {
  const markerIconType = useMemo(() => {
    if (allow.includes('SIGN') && allow.includes('STAMP')) {
      return 'CIRCLE';
    }

    if (allow.includes('SIGN')) {
      return 'SIGN';
    }

    if (allow.includes('STAMP') && uploadOnly) {
      return 'STAMP_UPLOAD_ONLY';
    }

    if (allow.includes('STAMP')) {
      return 'STAMP';
    }

    return 'CIRCLE';
  }, [allow, uploadOnly]);

  const iconRatio = useMemo(() => {
    if (
      markerIconType === 'CIRCLE' ||
      markerIconType === 'STAMP' ||
      markerIconType === 'STAMP_UPLOAD_ONLY'
    ) {
      return Math.max(
        Math.min(size.width, size.height) / 100.0 /* DEFAULT_SIZE */,
        MIN_ICON_SIZE / MIN_STAMP_SIZE.height
      );
    }
    return Math.max(size.height / 53.85 /* DEFAULT_SIZE */, 18.0 / 26.92);
  }, [markerIconType, size.height, size.width]);

  return {
    iconSize: createAbsoluteNumber(BASE_ICON_SIZE * iconRatio),
    markerIconType,
  };
}
